import { render, staticRenderFns } from "./FacetGroupContainer.vue?vue&type=template&id=c733aae6&"
import script from "./FacetGroupContainer.vue?vue&type=script&lang=js&"
export * from "./FacetGroupContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports